import Vue from "vue";

let globalTema = new Vue({
  data: { $tema: '#FBDC04' }
});

/**
 * Calcula a luminância percebida de uma cor hexadecimal.
 * Retorna um valor entre 0 (escuro) e 255 (claro).
 */
function getLuminance(hex) {
  const clean = (hex || '').replace('#', '').trim();
  const value = clean.length === 3 ? clean.split('').map((c) => c + c).join('') : clean;
  if (value.length !== 6) return 0;
  const r = parseInt(value.substring(0, 2), 16);
  const g = parseInt(value.substring(2, 4), 16);
  const b = parseInt(value.substring(4, 6), 16);
  if ([r, g, b].some((n) => Number.isNaN(n))) return 0;
  return 0.299 * r + 0.587 * g + 0.114 * b;
}

/**
 * Retorna true se a cor primária do tema é clara (luminância >= 160).
 */
function isPrimaryColorLight(vuetify) {
  return getLuminance(vuetify.theme.themes.light.primary) >= 160;
}

/**
 * Retorna a cor de contraste (#111827 ou #ffffff) para uma cor hex.
 * Uso: getContrastColor('#FCCF32') → '#111827'
 */
export function getContrastColor(hex) {
  return getLuminance(hex) >= 160 ? '#111827' : '#ffffff';
}

export { getLuminance };

Vue.mixin({
  computed: {
    $tema: {
      get: function () { return globalTema.$data.$tema },
      set: function (newTema) { globalTema.$data.$tema = newTema; }
    },

    /**
     * Retorna true se a cor primária é clara.
     * Uso: this.$isPrimaryLight
     */
    $isPrimaryLight() {
      return isPrimaryColorLight(this.$vuetify);
    },

    /**
     * Retorna a cor ideal para ícones/textos sobre fundo com cor primária.
     * Claro → '#111827' (escuro), Escuro → cor primária original.
     * Uso: this.$corIcone
     */
    $corIcone() {
      return this.$isPrimaryLight ? '#111827' : this.$vuetify.theme.themes.light.primary;
    },

    /**
     * Retorna a cor ideal para texto sobre fundo com cor primária preenchida.
     * Claro → '#111827', Escuro → '#ffffff'.
     * Uso: this.$corTextoPrimary
     */
    $corTextoPrimary() {
      return this.$isPrimaryLight ? '#111827' : '#ffffff';
    },
  }
})
